<template>
  <div class="row">
    <div class="col-xs-12 col-sm-6 col-md-8" style="margin: 0">
      <h3>历史数据统计</h3>
      <div class="row" style="padding: 0 30px 30px 30px;margin-top: 0;">
        <div class="row" style="background-color: #FFFFFF;border-radius:20px;border:thin solid #EC0404;padding: 10px 30px 30px 30px;margin-top: 0;">
<!--          <div class="row"><span style="margin-left: 20px;">历年开班数据统计</span></div>-->
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6">
              <!--历年开班数量统计-->
              <div id="clazzGraph" style="height: 350px;"></div>
            </div>
            <div class="col-xs-12 col-md-6">
              <!--历年开班数量统计-->
<!--              <div class="btn-group" style="width: 100%;">-->
<!--                <button type="button" class="btn btn-default" style="width: 90%;">{{ selectClazzYear }}</button>-->
<!--                <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  style="width: 10%;">-->
<!--                  <span class="caret"></span>-->
<!--                </button>-->
<!--                <ul class="dropdown-menu" role="menu" style="width: 90%;">-->
<!--                  <li v-for="(i,index) in clazzYear" @click="initClazzTypeCount(i)"><a href="#">{{i}}</a></li>-->
<!--                </ul>-->
<!--              </div>-->
              <div id="clazzTypeGraph" style="height: 300px;"></div>
            </div>
          </div>
<!--          <div class="row"><span style="margin-left: 20px;">历年课程数据统计</span></div>-->
          <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-6">
            <!--历年课程数量统计-->
            <div id="lessonGraph" style="height: 350px;"></div>
          </div>
          <div class="col-xs-12 col-md-6">
            <!--历年课程数量统计-->
<!--            <div class="btn-group" style="width: 100%;">-->
<!--              <button type="button" class="btn btn-default" style="width: 90%;">{{ selectLessonYear }}</button>-->
<!--              <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  style="width: 10%;">-->
<!--                <span class="caret"></span>-->
<!--              </button>-->
<!--              <ul class="dropdown-menu" role="menu" style="width: 90%;">-->
<!--                <li v-for="(i,index) in lessonYear" @click="initLessonTypeCount(i)"><a href="#">{{i}}</a></li>-->
<!--              </ul>-->
<!--            </div>-->
            <div id="lessonTypeGraph" style="height: 300px;"></div>
          </div>
        </div>
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6">
              <!--历年课程数量统计-->
<!--              <div class="row"><span style="margin-left: 20px;">历年学员总数统计</span></div>-->
              <div id="studentGraph" style="height: 350px;"></div>
            </div>
            <div class="col-xs-6 col-md-6">

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <h3>实时开班情况</h3>
      <div class="row" style="padding: 0 30px 30px 30px;margin-top: 0;">
        <div class="row" style="border-radius:20px;border:thin solid #EC0404;background-color: #FFFFFF;
        padding: 30px 30px 10px 30px;margin-top: 0;margin-bottom: 0;" v-if="realLessons.length > 0">
          <div v-for="item in realLessons" style="width:100%;display:inline-block;background-color: #F4F4F4;
          border-radius:10px;padding: 5px 30px 5px 30px;margin-bottom: 20px;min-height: 170px;">
            <h4>{{item.clazzName}}</h4>
            <p>开班时间：{{item.startDate}} --- {{item.endDate}}</p>
            <p>实时课程：{{item.lessonName?item.lessonName:'无'}}</p>
            <p>上课地点：{{item.roomName?item.roomName:'无'}}</p>
            <p>课程时间：{{item.time?item.time:'无'}}<span style="float:right;">实到：{{item.realStudents}}
              应到：{{!item.lessonName?'0':item.totalStudents}}</span></p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {getContentSize} from "./mainView";
import {schoolAxios} from "../main";
import * as echarts from 'echarts';
import Dictionary from "../json/dictionary.json"

export default {
  name: "dashboardContentPC",
  data(){
    return {
      token: this.$store.state.access_token,
      code: this.$store.state.code,
      realLessons:[],
      clazz:[],
      lesson:[],
      student:[],
      clazzYear:[],
      lessonYear:[],
      studentYear:[],
      clazzCount:[],
      lessonCount:[],
      studentCount:[],
      selectClazzYear:'',
      clazzTypeData:[],
      selectLessonYear:'',
      lessonTypeData:[],
      clazzTypeAction:'',
      lessonTypeAction:''
    }
  },
  mounted: function () {
    let this_ = this;
    this.$nextTick(function () {
    getContentSize();
    this_.getRealTimeLesson();
    this_.initHistoryData();
    setInterval(() => {
        this_.getRealTimeLesson()
    }, 5 * 60 * 1000)
    });

        
  // const token = this.$route.query.access_token;
  //   if(token){
  //     this_.$store.set("access_token", token);
  //     this_.$store.set("token_type", 'bearer');
  //   }

  //   // if(!this.token){
  //   //   setTimeout(function (){
  //   //     window.location.reload()
  //   //   }, 500)
  //   // }
  //   this.$nextTick(function () {
  //     getContentSize();
  //     this_.getRealTimeLesson();
  //     this_.initHistoryData();
  //     setInterval(() => {
  //       this_.getRealTimeLesson()
  //     }, 5 * 60 * 1000)
  //   });

  },
  methods:{
    getToken(){
      let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'user/exchange',
          params: {
            code: this_.code
          }
        }).then(function (resp) {
          if (resp.data && resp.data.data) {
            const token = resp.data.data.access_token;
            if (token) {
              this_.$store.set("access_token", token);
              this_.$store.set("token_type", 'bearer');
              this_.token = token;
              this_.loadData();
            }
          }
        })
    
    },
    loadData(){
      let this_ = this;
      this_.$nextTick(function () {
        getContentSize();
        this_.getRealTimeLesson();
        this_.initHistoryData();
        setInterval(() => {
          this_.getRealTimeLesson()
        }, 5 * 60 * 1000)
      });
    },
    //实时开班列表
    getRealTimeLesson(){
      let this_ = this;
      schoolAxios({
        method: 'get',
        url: 'lesson/findRealTimeClazzInfo',
        params: null
      }).then(function (resp) {
        let data = resp.data;
        this_.realLessons = data.list
      })
    },
    //历史数据统计
    initHistoryData(){
      let this_ = this;
      schoolAxios({
        method: 'get',
        url: 'clazz/findHistoryData',
        params: null
      }).then(function (resp) {
        let data = resp.data.data;
        // console.log('-----------------------data:',JSON.stringify(data))
        this_.clazz = data.clazz
        this_.lesson = data.lesson
        this_.student = data.student
        const classYearArr = this_.clazz.map(i => i.CLAZZYEAR);
        const classYearSet = new Set(classYearArr);
        this_.clazzYear = Array.from(classYearSet);
        this_.clazzYear.forEach(y=>{
          let c = 0
          this_.clazz.forEach(i=>{
            if(i.CLAZZYEAR == y){
              c += i.CLAZZCOUNT
            }
          })
          this_.clazzCount.push(c)
        })
        const lessonYearArr = this_.lesson.map(i => i.CLAZZYEAR);
        const lessonYearSet = new Set(lessonYearArr);
        this_.lessonYear = Array.from(lessonYearSet);
        this_.lessonYear.forEach(y=>{
          let c = 0
          this_.lesson.forEach(i=>{
            if(i.CLAZZYEAR == y){
              c += i.LESSONCOUNT
            }
          })
          this_.lessonCount.push(c)
        })
        const studenYearArr = this_.student.map(i => i.CLAZZYEAR);
        const studenYearSet = new Set(studenYearArr);
        this_.studentYear = Array.from(studenYearSet);
        this_.studentYear.forEach(y=>{
          let c = 0
          this_.student.forEach(i=>{
            if(i.CLAZZYEAR == y){
              c += i.STUDENTCOUNT
            }
          })
          this_.studentCount.push(c)
        })

        this_.createClazzCountGraph()
        this_.initClazzTypeCount('')
        this_.createLessonCountGraph()
        this_.initLessonTypeCount('')
        this_.createStudentCountGraph()
      })
    },
    //历年开班数量统计
    createClazzCountGraph(){
      let this_ = this;
      const chartDom = document.getElementById('clazzGraph');
      const myChart = echarts.init(chartDom, null, {
        renderer: 'canvas',
        useDirtyRect: false
      });
      let option = {
        title: {
          text: '历年开班数据统计',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: this_.clazzYear
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this_.clazzCount,
            type: 'bar'
          }
        ],
        emphasis: {
          label: {
            show: true,
            fontSize: 30,
            formatter: '{c}',
          }
        },
      };
      if (option && typeof option === 'object') {
        myChart.setOption(option);
      }
      myChart.on('click',function(params, charts, event) {
        this_.initClazzTypeCount(params.name)
        this_.selectClazzYear = params.name
      });
      window.addEventListener('resize', myChart.resize);
    },
    //历年开班类型数量统计
    initClazzTypeCount(year){
      let this_ = this;
      this_.clazzTypeData.length = 0
      this_.selectClazzYear = year
      if(year == ''){
        let data = new Map()
        this_.clazz.forEach(i=>{
          let type = Dictionary.clazz_type[i.TYPE] ? Dictionary.clazz_type[i.TYPE]: ''
          if(data.has(type)){
            data.set(type,data.get(type) + i.CLAZZCOUNT)
          } else{
            data.set(type,i.CLAZZCOUNT)
          }
        })
        for(const [key,val] of data){
          this_.clazzTypeData.push({name:key, value:val})
        }
      } else{
        this_.clazz.forEach(i=>{
          let type = Dictionary.clazz_type[i.TYPE]
          if(year == i.CLAZZYEAR){
            this_.clazzTypeData.push({name:type?type:i.TYPE, value:i.CLAZZCOUNT})
          }
        })
      }
      this_.createClazzTypeCountGraph()
    },
    //历年开班类型数量统计
    createClazzTypeCountGraph(){
      let this_ = this;
      const chartDom = document.getElementById('clazzTypeGraph');
      const myChart = echarts.init(chartDom, null, {
        renderer: 'canvas',
        useDirtyRect: false
      });
      let option = {
        title: {
          text: this_.selectClazzYear? this_.selectClazzYear + '年班次类型统计' : '班次类型统计',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 'auto',
          top: 'auto',
          bottom: 'auto',
          left: 'auto'
        },
        series: [
          {
            name: '数量',
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            left: '20%',
            // itemStyle: {
            //   borderRadius: 10,
            //   borderColor: '#fff',
            //   borderWidth: 2
            // },
            label: {
              show: false,
              position: 'center',
              fontSize: 20,
              formatter: '{b}\n{c}',
              rich:{
                d_style:{
                  fontSize: 80
                },
                per_style:{
                  fontSize: 60
                },
                b_style:{
                  fontSize: 42
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 30,
                // fontWeight: 'bold'
              },
              scale: true, // 设置高亮时放大图形
              scaleSize: 20
            },
            labelLine: {
              show: false
            },
            data: this_.clazzTypeData
          }
        ]
      };
      if (option && typeof option === 'object') {
        myChart.setOption(option);
      }
      if(this_.clazzTypeAction)
        clearInterval(this_.clazzTypeAction);
      let currentIndex = -1; // 当前高亮图形在饼图数据中的下标
      let changePieInterval = setInterval(selectPie, 1000); // 设置自动切换高亮图形的定时器
      this_.clazzTypeAction = changePieInterval

      function highlightPie() { // 取消所有高亮并高亮当前图形
        for(var idx in option.series[0].data)
          // 遍历饼图数据，取消所有图形的高亮效果
          myChart.dispatchAction({
            type: 'downplay',
            seriesIndex: 0,
            dataIndex: idx
          });
        // 高亮当前图形
        myChart.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex: currentIndex
        });
      }

      myChart.on('mouseover', (params) => { // 用户鼠标悬浮到某一图形时，停止自动切换并高亮鼠标悬浮的图形
        if(changePieInterval)
          clearInterval(changePieInterval);
        currentIndex = params.dataIndex;
        highlightPie();
      });

      myChart.on('mouseout', (params) => { // 用户鼠标移出时，重新开始自动切换
        if(changePieInterval)
          clearInterval(changePieInterval);
        changePieInterval = setInterval(selectPie, 1000);
      });

      function selectPie() { // 高亮效果切换到下一个图形
        var dataLen = option.series[0].data.length;
        currentIndex = (currentIndex + 1) % dataLen;
        highlightPie();
      }

      window.addEventListener('resize', myChart.resize);
    },
    //历年课程数量统计
    createLessonCountGraph(){
      let this_ = this;
      const chartDom = document.getElementById('lessonGraph');
      const myChart = echarts.init(chartDom, null, {
        renderer: 'canvas',
        useDirtyRect: false
      });
      let option = {
        title: {
          text: '历年课程数据统计',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: this_.lessonYear
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this_.lessonCount,
            type: 'bar',
            color: '#FCA404'
          }
        ],
        emphasis: {
          label: {
            show: true,
            fontSize: 30,
            formatter: '{c}',
          }
        },
      };
      if (option && typeof option === 'object') {
        myChart.setOption(option);
      }
      myChart.on('click',function(params, charts, event) {
        this_.initLessonTypeCount(params.name)
        this_.selectLessonYear = params.name
      });
      window.addEventListener('resize', myChart.resize);
    },
    //历年课程类型数量统计
    initLessonTypeCount(year){
      let this_ = this;
      this_.lessonTypeData.length = 0
      this_.selectLessonYear = year
      if(year == ''){
        let data = new Map()
        this_.lesson.forEach(i=>{
          let type = Dictionary.lesson_type[i.TYPE] ? Dictionary.lesson_type[i.TYPE]: ''
          if(data.has(type)){
            data.set(type,data.get(type) + i.LESSONCOUNT)
          } else{
            data.set(type,i.LESSONCOUNT)
          }
        })
        for(const [key,val] of data){
          this_.lessonTypeData.push({name:key, value:val})
        }
      } else {
        this_.lesson.forEach(i => {
          let type = Dictionary.lesson_type[i.TYPE]
          if (year == i.CLAZZYEAR) {
            this_.lessonTypeData.push({name: type ? type : i.TYPE, value: i.LESSONCOUNT})
          }
        })
      }
      this_.createLessonTypeCountGraph()
    },
    //历年课程类型数量统计
    createLessonTypeCountGraph(){
      let this_ = this;
      const chartDom = document.getElementById('lessonTypeGraph');
      const myChart = echarts.init(chartDom, null, {
        renderer: 'canvas',
        useDirtyRect: false
      });
      let option = {
        title: {
          text: this_.selectLessonYear? this_.selectLessonYear + '年课程类型统计' : '课程类型统计',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 'auto',
          top: 'auto',
          bottom: 'auto',
          left: 'auto'
        },
        series: [
          {
            name: '数量',
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            left: '20%',
            // itemStyle: {
            //   borderRadius: 10,
            //   borderColor: '#fff',
            //   borderWidth: 2
            // },
            label: {
              show: false,
              position: 'center',
              fontSize: 20,
              formatter: '{b}\n{c}',
              rich:{
                d_style:{
                  fontSize: 80
                },
                per_style:{
                  fontSize: 60
                },
                b_style:{
                  fontSize: 42
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 30,
                formatter: '{b}\n{c}',
              },
              scale: true, // 设置高亮时放大图形
              scaleSize: 20
            },
            labelLine: {
              show: false
            },
            data: this_.lessonTypeData
          }
        ]
      };
      if (option && typeof option === 'object') {
        myChart.setOption(option);
      }

      if(this_.lessonTypeAction)
        clearInterval(this_.lessonTypeAction);
      let currentIndex = -1; // 当前高亮图形在饼图数据中的下标
      let changePieInterval = setInterval(selectPie, 1000); // 设置自动切换高亮图形的定时器
      this_.lessonTypeAction = changePieInterval

      function highlightPie() { // 取消所有高亮并高亮当前图形
        for(var idx in option.series[0].data)
          // 遍历饼图数据，取消所有图形的高亮效果
          myChart.dispatchAction({
            type: 'downplay',
            seriesIndex: 0,
            dataIndex: idx
          });
        // 高亮当前图形
        myChart.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex: currentIndex
        });
      }

      myChart.on('mouseover', (params) => { // 用户鼠标悬浮到某一图形时，停止自动切换并高亮鼠标悬浮的图形
        if(changePieInterval)
          clearInterval(changePieInterval);
        currentIndex = params.dataIndex;
        highlightPie();
      });

      myChart.on('mouseout', (params) => { // 用户鼠标移出时，重新开始自动切换
        if(changePieInterval)
          clearInterval(changePieInterval);
        changePieInterval = setInterval(selectPie, 1000);
      });

      function selectPie() { // 高亮效果切换到下一个图形
        var dataLen = option.series[0].data.length;
        currentIndex = (currentIndex + 1) % dataLen;
        highlightPie();
      }

      window.addEventListener('resize', myChart.resize);
    },
    //历年学员总数统计
    createStudentCountGraph(){
      let this_ = this;
      const chartDom = document.getElementById('studentGraph');
      const myChart = echarts.init(chartDom, null, {
        renderer: 'canvas',
        useDirtyRect: false
      });
      let option = {
        title: {
          text: '历年学员数据统计',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: this_.studentYear
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this_.studentCount,
            type: 'line',
            color: '#EC0404',
          }
        ],
        emphasis: {
          label: {
            show: true,
            fontSize: 30,
            formatter: '{c}',
          }
        },
        lineStyle: {
          color: '#EC0404'
        }
      };
      if (option && typeof option === 'object') {
        myChart.setOption(option);
      }
      window.addEventListener('resize', myChart.resize);
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboardContentPC.vue